<script>
    import { onMount } from "svelte";
    import { loggedInDoctorDetail, user } from "../../stores";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";
    import Calendar from "../../Pages/Calendar/Calendar.svelte";

    export let params;
    export let tokenRefresh = undefined;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

{#await tokenRefresh then tokenRefreshResult}
    {#if tokenRefreshResult === "valid" || tokenRefreshResult === "refreshed"}
        <div class="flex flex-1 flex-col w-full px-6 py-4 bg-gray-200">
            <Calendar
                {params}
                url={$user.role == 2 ? "/Calendar/" : "/Calendar"}
                accountId={$user.role == 2 ? $loggedInDoctorDetail.id : Number(0)}
                isCalendarRoute
            />
        </div>
    {/if}
{/await}
